import { IconBuildingSkyscraper } from '@tabler/icons-react';
import React, { useState } from 'react';
import { OverlayTrigger, Popover, Spinner } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { getApi } from '../../api/call.api';
import { urlApi } from '../../api/url.api';
import { ORG_LIST, PROFILE } from '../../statics/localStorage';

const SwitchOrganization = () => {

    const profileData = PROFILE();
    const navigate = useNavigate();
    const [orgList, setOrgList] = useState(ORG_LIST() || []);
    const [loading, setLoading] = useState(false);

    const getOrganizationList = async () => {
        let resp = await getApi(urlApi.getOrganizationList);
        if (resp.responseCode === 200) {
            setOrgList(resp.data)
        } else {
            setOrgList([]);
        }
    }

    const selectOrganization = async (organization) => {
        setLoading(true);
        let resp = await getApi(urlApi.switchOrganization + organization?.organizationId);
        setLoading(false);
        if (resp.responseCode === 200) {
            navigate('/', { replace: true })
        } else {
            toast.error(resp.message);
        }
    }


    return (
        <OverlayTrigger
            trigger="click"
            key={'instituteComponent'}
            placement={'bottom-end'}
            rootClose={true}
            overlay={
                <Popover id='popover-basic'>
                    <Popover.Header as="h5" className='text-sm'>{`Select Organization`}</Popover.Header>
                    <Popover.Body>
                        <div>
                            {loading ? <Spinner /> :

                                orgList?.map((item, index) => {
                                    return (
                                        <div key={index} className={`flex items-center !gap-3 !px-4 py-2 ${profileData?.defaultOrganizationId != item?.organizationId && 'hover:!bg-slate-100 hover:!text-black'} rounded-md`}
                                            onClick={() => selectOrganization(item)}
                                            style={{ cursor: 'pointer', color: profileData?.defaultOrganizationId == item?.organizationId ? 'white' : 'var(--dim-gray)', backgroundColor: profileData?.defaultOrganizationId == item?.organizationId ? 'var(--primary)' : 'var(--dim-gray)' }}>
                                            <img src={item?.organizationIcon ?? process.env.PUBLIC_URL + "/icons/logo.svg"} alt="" style={{ height: 30, aspectRatio: '1/1', borderRadius: '100%', objectFit: 'cover' }} />
                                            <div>
                                                <p className='mb-0 font-semibold'>{item?.name}</p>
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </div>
                        <div className='text-center mt-2.5'>
                            <Link className='text-center underline' style={{ color: 'var(--gray)' }} replace to={"/settings?tab=2"} onClick={() => document.body.click()}>Know More</Link>
                        </div>
                    </Popover.Body>
                </Popover>
            }
        >
            <button className='flex items-center justify-center' title='Select Organizations' onClick={() => getOrganizationList()}>
                {orgList?.find(item => item?.organizationId == profileData?.defaultOrganizationId)?.name ? <img className='h-9 w-9 rounded-full object-cover' src={orgList?.find(item => item?.organizationId == profileData?.defaultOrganizationId)?.organizationIcon} alt='' /> : <div className='h-full aspect-square rounded-full text-white p-1.5 bg-primary'> <IconBuildingSkyscraper /></div>}
            </button>
        </OverlayTrigger>
    )
}

export default SwitchOrganization